import React from 'react';
import { useAuth } from '../../contexts/AuthContext'; // Import useAuth to get user info
import { useLocation } from 'react-router-dom'; // Import useLocation to get the current route

const Topbar = () => {
    const { authData } = useAuth(); // Access the current user from AuthContext
    const location = useLocation(); // Get the current route

    // Map routes to page titles
    const pageTitles = {
        '/dashboard/preload': 'Preload File',
        '/dashboard/reports': 'Reports',
        '/dashboard/history': 'History',
        '/dashboard/users': 'Manage Users',
        '/dashboard/account': 'My Account',
    };

    // Get the current page title based on the route
    const currentTitle = pageTitles[location.pathname] || 'Dashboard';

    return (
        <header class="bg-white border-b border-gray-200 py-4 px-6 flex items-center justify-between">
            <div>
                <h1 id="dashboardTitle" class="text-xl font-semibold text-gray-800">{currentTitle}</h1>
            </div>
            <div class="flex items-center space-x-4">
                <div class="relative">
                    <button class="text-gray-500 hover:text-gray-700">
                        <i class="fas fa-bell"></i>
                    </button>
                    <span class="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500"></span>
                </div>
                <div class="flex items-center space-x-2">
                    <div class="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
                        <i class="fas fa-user text-blue-600"></i>
                    </div>
                    <span class="text-gray-700">{authData?.displayName || 'User'}</span>
                </div>
            </div>
        </header>
    );
};

export default Topbar;